import { lightGreen, lightBlue, red } from '@material-ui/core/colors'

const styles = (theme) => ({
  destroyTableCell: {
    backgroundColor: red[50],
  },
  justifyHeight: {
    height: '100%',
  },
  createTableCell: {
    backgroundColor: lightGreen[50],
  },
  updateTableCell: {
    backgroundColor: lightBlue[50],
  },
  noCellPadding: {
    padding: 0,
  },
  root: {
    cursor: 'pointer',
    '& > *': {
      borderBottom: 'unset',
    },
  },
  collapseBackground: {
    backgroundColor: '#F4F6F8',
  },
  changesTable: {
    tableLayout: 'fixed',
    width: '100%',
  },
  changeCell: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
})

export default styles
